export default "__VITE_ASSET__1TL4kbsR__"